import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { addYears, subDays, differenceInCalendarDays, addDays, startOfDay, parse } from 'date-fns';
import { InspectionStorageService } from 'src/app/modules/course-accreditation/services/inspection-storage.service';
import { SaveInspectionDecisionDto } from 'src/app/modules/course-accreditation/DTO/saveInspectionDecisionDto';

@Component({
  selector: 'app-decision',
  templateUrl: './decision.component.html',
  styleUrls: ['./decision.component.scss']
})
export class DecisionComponent implements OnInit {

  detailsInspectionReportList: any = [];
  inspectionDecisionInfo: any;
  recommendationTypeList: any;
  recommendationTypeListForRegistration: any;
  upDatedRemarks: FormControl = new FormControl();
  inspectionId: number;

  total: number;
  size: number = 10;
  page: number = 1;
  sortingKey: string;
  sortingValue: string;
  value: any = null;

  isVisible = false;
  isConfirmLoading = false;

  currentInspectionDetailsRow: any;
  detailsInspectionReportListCheckCount:number = 0;
  detailsInspectionReportListRowCount:number = 0;

  firstForm: FormGroup;
  secondForm: FormGroup;
  thirdForm: FormGroup;
  fourthForm: FormGroup;
  rowIdFormDataMap = new Map<number, any>(); // used to save the form data value of each row

  currentApplicationTypeId: number;

  isSubmitAll: boolean = false;

  currentValidFromDate: Date = new Date();
  currentDate: Date = new Date();
  tomorrow: Date = addDays(this.currentDate, 1);
  januaryFirst2020: Date = parse('2020-01-01', 'yyyy-MM-dd', new Date());
  rollbackBtnDisabled = false;
  enableSaveAndSubmitBtn:boolean = false;

  nsdaOfficerName: string;
  designation: string;

  approveId: number;
  notApproveId: number;
  onHoldId: number;

  isScrutinyDecisionCompleted: boolean = false;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private inspectionStorageService: InspectionStorageService,
    private notification: NzNotificationService
  ) {}

  ngOnInit() {
    this.inspectionId = this.route.snapshot.params.inspectionId;
    this.getInspectionDecisionResult();
    this.getInspectionRecommendationByType('D');
    this.createFirstForm();
    this.createThirdForm();
    this.createFourthForm();
    this.createSecondForm();
  }

  updateSaveAndSubmitBtn(detailsInspectionReportList: any) {

    let isOnHold: boolean = false;
    let isDecisionComplete: boolean = false;
    for( let data of detailsInspectionReportList) {

      if (data['finalDecisionId'] || data['finalDecisionCourseId'] || data['finalDecisionAssessmentId']) {
        isDecisionComplete = true;
      //   if (data['decisionFinalInspectionRecomAssessment'] == 'On-Hold' || data['decisionFinalInspectionRecomCourse'] == 'On-Hold') {
      //     isOnHold = true;
      //   }
      }

      // if (data['decisionFinalInspectionRecomAssessment'] == 'On-Hold' || data['decisionFinalInspectionRecomCourse'] == 'On-Hold') {
      //   isOnHold = true;
      // }
    }

    if (this.isScrutinyDecisionCompleted) {
      if(isDecisionComplete) {
        this.enableSaveAndSubmitBtn = true;
      } else {
        this.enableSaveAndSubmitBtn = false;
      }
    }

  }

  getInspectionDecisionResult() {
    this.inspectionStorageService
      .getStpScrutinyDecisionByInspectionId(this.inspectionId)
      .subscribe(
        (res) => {
          this.upDatedRemarks.setValue(res.data?.correctionRemarks);
          this.inspectionDecisionInfo = res['data'];
          let nsdaOfficerId = res.data?.nsdaOfficer;
          this.isScrutinyDecisionCompleted =  res.data?.isScrutinyDecisionCompleted;
          if(nsdaOfficerId!=null){
            this.getNsdaOfficer(nsdaOfficerId);
          }
          this.detailsInspectionReportList =
            this.inspectionDecisionInfo[
              'inspectionDecisionDetailsReportPayload'
            ];
          this.detailsInspectionReportListRowCount = this.detailsInspectionReportList.length;
          this.updateSaveAndSubmitBtn(this.detailsInspectionReportList);
          let rowCount = 1;
          this.detailsInspectionReportList.forEach((d: any) => {
            if (d.inspectionRegistrationReportId != null) {
              d['type'] = 'STP';
            } else
            d['type'] = 'Occupation';
            if(d.finalDecisionId || d.finalDecisionCourseId || d.finalDecisionAssessmentId){
              d['isUpdated'] = true;
            }
            else{
            d['isUpdated'] = false;
            }
            d['rowId'] = rowCount;
            rowCount += 1;
          });
          this.updateRowIdFormDataMap();
        },
        (error) => {
          this.notification.error(
            'Error!',
            'Error getting scrutiny inspection result info'
          );
        }
      );
  }

  updateRowIdFormDataMap() {
    for (let d of this.detailsInspectionReportList) {
      let obj = {
        firstSelect: null,
        validDateRange: [null, null],
        secondSelect: null,
        fromDate: null,
        toDate: null,
        fromDateLast: null,
        toDateLast: null,
        validDateRangeLast: [null, null],
      };
      switch (d.applicationTypeId) {
        // case for Registration
        case 4:
          obj['firstSelect'] = d?.finalDecisionId;
          obj['fromDate'] = d.validFrom;
          obj['toDate'] = d.validTo;
          break;

        // case for Course Accreditation
        case 1:
          obj['firstSelect'] = d?.finalDecisionCourseId;
          obj['fromDate'] = d.validFromCourse;
          obj['toDate'] = d.validToCourse;
          break;

        // case for Assessment Center Accreditation
        case 2:
          obj['firstSelect'] = d?.finalDecisionAssessmentId;
          obj['fromDate'] = d.validFromAssessment;
          obj['toDate'] = d.validToAssessment;
          break;

        // case for Course and Assessment Center Accreditation
        case 3:
          obj['firstSelect'] = d?.finalDecisionCourseId;
          obj['fromDate'] = d?.validFromCourse;
          obj['toDate'] = d?.validToCourse;
          // obj['validDateRange'][0] = d.validFromCourse;
          // obj['validDateRange'][1] = d.validToCourse;

          obj['secondSelect'] = d?.finalDecisionAssessmentId;
          // obj['validDateRangeLast'][0] = d.validFromAssessment;
          // obj['validDateRangeLast'][1] = d.validToAssessment;
          obj['fromDateLast'] = d?.validFromAssessment;
          obj['toDateLast'] = d?.validToAssessment;

          break;
      }
      this.rowIdFormDataMap.set(d.rowId, obj);
    }
  }

  calculateAndSetCheckCount(){
    this.rowIdFormDataMap.forEach((item:any)=>{
      if(item.firstSelect)
      {
        this.detailsInspectionReportListCheckCount ++;
      }
    })
    if(this.detailsInspectionReportListRowCount == this.detailsInspectionReportListCheckCount || this.isSubmitAll == true){
        this.isSubmitAll = true;
    }else{
        this.isSubmitAll = false;
    }
  }

  updateStatusNameWithID(recommendationTypeList: any) {
    if(!recommendationTypeList){
      return;
    }

    for(let recommendation of recommendationTypeList) {
      if(recommendation.name == 'Approved') {
        this.approveId = recommendation.id;
      } else if (recommendation.name == 'Not-Approved') {
        this.notApproveId = recommendation.id;
      } else if (recommendation.name = 'On-Hold') {
        this.onHoldId = recommendation.id;
      }
    }
  }

  getInspectionRecommendationByType(type: string) {
    this.inspectionStorageService
      .getInspectionRecommendationByType(type)
      .subscribe(
        (res) => {
          this.recommendationTypeList = res['data'];
          this.recommendationTypeListForRegistration = res['data'].filter(
            (d: any) => d.name != 'On-Hold'
          ); // remove On-Hold for Registration

          this.updateStatusNameWithID(this.recommendationTypeList);
        },
        (error) => {
          this.notification.error(
            'Error!',
            'Error getting recommendation type'
          );
        }
      );
  }

  getInspectionDecisionDtoList() {
    let saveInspectionDecisionDtoList: SaveInspectionDecisionDto[] = [];

    for (let d of this.detailsInspectionReportList) {
      let saveInspectionDecisionDto = new SaveInspectionDecisionDto();
      const formData = this.rowIdFormDataMap.get(d.rowId);

      saveInspectionDecisionDto.type = 'Registration';
      saveInspectionDecisionDto.inspectionRegistrationReportId = d.inspectionRegistrationReportId;
      saveInspectionDecisionDto.finalDecisionId = formData.firstSelect;

      if (formData?.fromDate && formData?.toDate) {
        saveInspectionDecisionDto.validFrom = formData.fromDate;
        saveInspectionDecisionDto.validTo = formData.toDate;
      } else {
        saveInspectionDecisionDto.validFrom = null as any;
        saveInspectionDecisionDto.validTo = null as any;
      }

      saveInspectionDecisionDtoList.push(saveInspectionDecisionDto);
    }

    return saveInspectionDecisionDtoList;
  }

  getNsdaOfficer(officer_id:number){
    this.inspectionStorageService.getUserByUserId(officer_id)
    .subscribe((res)=>{
      this.nsdaOfficerName = res?.name;
      this.designation = res?.designation;
    })
  }


  onViewStpSac(inspectionId: number): void {
    this.router.navigate(
      [
        `home/stp-registration/stp-sac-inspection-report-preview/${inspectionId}`,
      ],
      {
        queryParams: {
          type: 'view',
        },
      }
    );
  }

  onAssesmentDecisionSave() {
    let saveInspectionDecisionDtoList = this.getInspectionDecisionDtoList();

    this.inspectionStorageService
      .saveStpScrutinyDecision(saveInspectionDecisionDtoList)
      .subscribe(
        (res) => {
          if (res['success']) {
            this.notification.success(
              'Success!',
              'Scrutiny Inspection Decision Result Information saved successfully'
            );
            this.calculateAndSetCheckCount();
          } else {
            this.notification.error('Error!', res['message']);
          }
        },
        (error) => {
          this.notification.error(
            'Error!',
            'Error Saving scrutiny inspection decision result'
          );
        }
      );
  }

  onAssesmentDecisionSubmit() {
    this.inspectionStorageService
      .submitStpDecision(this.inspectionId)
      .subscribe(
        (res) => {
          if (res['success']) {
            this.notification.success(
              'Success!',
              'Scrutiny Inspection Decision Result Information submitted successfully'
            );
            this.router.navigate(['home/stp-registration/stp-applications']);
          } else {
            this.notification.error('Error!', res['message']);
          }
        },
        (error) => {
          this.notification.error(
            'Error!',
            'Error Submitting scrutiny inspection result'
          );
        }
      );
  }

  onAssesmentDecisionRollback() {
    // rollback remarks are mandatory
    if (!this.upDatedRemarks.value || !String(this.upDatedRemarks.value).trim()) {
      this.notification.warning('Warning!', 'Please input rollback remarks first !');
      return;
    }
    this.rollbackBtnDisabled = true;
    this.inspectionStorageService
      .rollBackStpScrutinyDecisionByInspectionId(this.inspectionId,this.upDatedRemarks.value)
      .subscribe(
        (res) => {
          if (res['success']) {
            this.notification.success(
              'Success!',
              'Scrutiny Inspection Decision Result Information rollback successfully'
            );
            this.router.navigate(['home/stp-registration/stp-applications']);
          } else {
            this.notification.error('Error!', res['message']);
          }
          this.rollbackBtnDisabled = false;
        },
        (error) => {
          this.notification.error(
            'Error!',
            'Error Rollback scrutiny inspection result'
          );
          this.rollbackBtnDisabled = false;
        }
      );
  }

  onQueryParamsChange(params: NzTableQueryParams): void {
    this.page = params.pageIndex;
    this.size = params.pageSize;
    params.sort.forEach((element: { value: string | null; key: string }) => {
      if (element.value != null) {
        this.sortingKey = element.key;
        this.sortingValue = element.value;
      }
    });
    // this.loadApplicatsFromServer();
  }

  showModal(rowData: any): void {
    this.currentApplicationTypeId = rowData.applicationTypeId;
    this.currentInspectionDetailsRow = rowData;
    this.isVisible = true;
    this.firstForm.reset();
    this.thirdForm.reset();
    this.fourthForm.reset();
    this.secondForm.reset();

    if (this.rowIdFormDataMap.has(rowData.rowId)) {
      if (this.currentApplicationTypeId == 3) {
        let values = this.rowIdFormDataMap.get(rowData.rowId);
        let { firstSelect, fromDate, toDate, secondSelect, fromDateLast, toDateLast } =
          values;

        if (fromDate && toDate == null) {
          fromDate = [];
          toDate = [];
        }

        if (fromDateLast && toDateLast == null) {
          fromDateLast = [];
          toDateLast = [];
        }

        this.secondForm.patchValue({
          firstSelect,
          fromDate,
          toDate,
          secondSelect,
          fromDateLast,
          toDateLast,
        });

        this.secondForm.updateValueAndValidity();
      } else if (this.currentApplicationTypeId == 1) {
        let values = this.rowIdFormDataMap.get(rowData.rowId);
        let { firstSelect, fromDate, toDate  } = values;

        if (fromDate && toDate == null) {
          fromDate = [];
          toDate = [];
        }

        this.thirdForm.patchValue({
          firstSelect,
          fromDate,
          toDate,
        });

        this.thirdForm.updateValueAndValidity();
      }else if (this.currentApplicationTypeId == 2) {
        let values = this.rowIdFormDataMap.get(rowData.rowId);
        let { firstSelect, fromDate, toDate, } = values;

        if (fromDate && toDate == null) {
          fromDate = [];
          toDate = [];
        }

        this.fourthForm.patchValue({
          firstSelect,
          fromDate,
          toDate,
        });

        this.fourthForm.updateValueAndValidity();
      }else {
        let values = this.rowIdFormDataMap.get(rowData.rowId);
        let { firstSelect, fromDate, toDate } = values;

        if (fromDate && toDate == null) {
          fromDate = [];
          toDate = [];
        }

        this.firstForm.patchValue({
          firstSelect,
          fromDate,
          toDate,
        });

        this.firstForm.updateValueAndValidity();
      }
    }
  }

  handleOk(): void {
    if (this.currentApplicationTypeId == 3) {
      if (this.secondForm.invalid) {
        this.notification.info('info', 'Please input all required fields');
        return;
      }

      this.rowIdFormDataMap.set(
        this.currentInspectionDetailsRow.rowId,
        this.secondForm.getRawValue()
      );
    }else if (this.currentApplicationTypeId == 1){
      if (this.thirdForm.invalid) {
        this.notification.info('info', 'Please input all required fields');
        return;
      }

      this.rowIdFormDataMap.set(
        this.currentInspectionDetailsRow.rowId,
        this.thirdForm.getRawValue()
      );
    }else if (this.currentApplicationTypeId == 2){
      if (this.fourthForm.invalid) {
        this.notification.info('info', 'Please input all required fields');
        return;
      }

      this.rowIdFormDataMap.set(
        this.currentInspectionDetailsRow.rowId,
        this.fourthForm.getRawValue()
      );
    } else{
      if (this.firstForm.invalid) {
        this.notification.info('info', 'Please input all required fields');
        return;
      }

      this.rowIdFormDataMap.set(
        this.currentInspectionDetailsRow.rowId,
        this.firstForm.getRawValue()
      );
    }

    this.detailsInspectionReportList.forEach((d: any) => {
      if (d.rowId == this.currentInspectionDetailsRow.rowId) {
        d['isUpdated'] = true;
      }
    });

    this.isVisible = false;
  }

  handleCancel(): void {
    this.isVisible = false;
  }

  createFirstForm() {
    this.firstForm = this.fb.group({
      firstSelect: ['', Validators.required],
      fromDate: [Date, Validators.required],
      toDate: [Date, Validators.required]
    });
  }

  createThirdForm() {
    this.thirdForm = this.fb.group({
      firstSelect: ['', Validators.required],
      fromDate: [Date, Validators.required],
      toDate: [Date, Validators.required]
    });
  }

  createFourthForm() {
    this.fourthForm = this.fb.group({
      firstSelect: ['', Validators.required],
      fromDate: [Date, Validators.required],
      toDate: [Date, Validators.required]
    });
  }

  createSecondForm() {
    this.secondForm = this.fb.group({
      firstSelect: ['', Validators.required],
      fromDate: [Date, Validators.required],
      toDate: [Date, Validators.required],
      secondSelect: ['', Validators.required],
      fromDateLast: [Date, Validators.required],
      toDateLast: [Date, Validators.required]
    });
  }

  // Approve chosen: the start date is not editable, so a missing one is pre-filled with today (a new STP
  // has no previous approval) and a missing end date with start + years - 1 day; the end stays editable.
  // (These forms are created with the Date constructor as the initial value, so "missing" = not a date.)
  private prefillApprovalDates(form: FormGroup, fromKey: string, toKey: string, years: number): void {
    const hasDate = (value: any) => value instanceof Date || typeof value === 'string';
    if (!hasDate(form.get(fromKey)?.value)) {
      form.get(fromKey)?.setValue(startOfDay(new Date()));
    }
    if (!hasDate(form.get(toKey)?.value)) {
      form.get(toKey)?.setValue(subDays(addYears(new Date(form.get(fromKey)?.value), years), 1));
    }
  }

  // for not-approved and on-hold status, valid date range will be disabled
  onFirstSelectFirstForm(recommendId: any) {
    if (recommendId == this.notApproveId || recommendId == this.onHoldId) {
      this.firstForm.controls['fromDate'].reset();
      this.firstForm.controls['fromDate'].disable();
      this.firstForm.controls['toDate'].reset();
      this.firstForm.controls['toDate'].disable();
    } else {
      this.firstForm.controls['toDate'].enable();
      if (recommendId == this.approveId) { this.prefillApprovalDates(this.firstForm, 'fromDate', 'toDate', 5); }
    }
  }

  onFirstSelectThirdForm(recommendId: any) {
    if (recommendId == this.notApproveId || recommendId == this.onHoldId) {
      this.thirdForm.controls['fromDate'].reset();
      this.thirdForm.controls['fromDate'].disable();
      this.thirdForm.controls['toDate'].reset();
      this.thirdForm.controls['toDate'].disable();
    } else {
      this.thirdForm.controls['toDate'].enable();
      if (recommendId == this.approveId) { this.prefillApprovalDates(this.thirdForm, 'fromDate', 'toDate', 2); }
    }
  }

  onFirstSelectFourthForm(recommendId: any) {
    if (recommendId == this.notApproveId || recommendId == this.onHoldId) {
      this.fourthForm.controls['fromDate'].reset();
      this.fourthForm.controls['fromDate'].disable();
      this.fourthForm.controls['toDate'].reset();
      this.fourthForm.controls['toDate'].disable();
    } else {
      this.fourthForm.controls['toDate'].enable();
      if (recommendId == this.approveId) { this.prefillApprovalDates(this.fourthForm, 'fromDate', 'toDate', 2); }
    }
  }

  onFirstSelectSecondForm(recommendId: any) {
    if (recommendId == this.notApproveId || recommendId == this.onHoldId) {
      this.secondForm.controls['fromDate'].reset();
      this.secondForm.controls['fromDate'].disable();
      this.secondForm.controls['toDate'].reset();
      this.secondForm.controls['toDate'].disable();
    } else {
      this.secondForm.controls['toDate'].enable();
      if (recommendId == this.approveId) { this.prefillApprovalDates(this.secondForm, 'fromDate', 'toDate', 2); }
    }
  }

  onSecondSelectSecondForm(recommendId: any) {
    if (recommendId == this.notApproveId || recommendId == this.onHoldId) {
      this.secondForm.controls['fromDateLast'].reset();
      this.secondForm.controls['fromDateLast'].disable();
      this.secondForm.controls['toDateLast'].reset();
      this.secondForm.controls['toDateLast'].disable();
    } else {
      this.secondForm.controls['toDateLast'].enable();
      if (recommendId == this.approveId) { this.prefillApprovalDates(this.secondForm, 'fromDateLast', 'toDateLast', 2); }
    }
  }

  updateToDateFirstForm(fromDate: Date): void {
    const toDateControl = this.firstForm.get('toDate');
    if (fromDate) {
      const toDate = subDays(addYears(fromDate, 5), 1);
      toDateControl?.setValue(toDate);
    } else {
      toDateControl?.setValue(null);
    }
  }

  updateToDateThirdForm(fromDate: Date): void {
    const toDateControl = this.thirdForm.get('toDate');
    if (fromDate) {
      const toDate = subDays(addYears(fromDate, 2), 1);
      toDateControl?.setValue(toDate);
    } else {
      toDateControl?.setValue(null);
    }
  }

  updateToDateFourthForm(fromDate: Date): void {
    const toDateControl = this.fourthForm.get('toDate');
    if (fromDate) {
      const toDate = subDays(addYears(fromDate, 2), 1);
      toDateControl?.setValue(toDate);
    } else {
      toDateControl?.setValue(null);
    }
  }

  updateToDateSecondForm(fromDate: Date): void {
    const toDateControl = this.secondForm.get('toDate');
    if (fromDate) {
      const toDate = subDays(addYears(fromDate, 2), 1);
      toDateControl?.setValue(toDate);
    } else {
      toDateControl?.setValue(null);
    }
  }

  updateToDateLastSecondForm(fromDateLast: Date): void {
    const toDateLastControl = this.secondForm.get('toDateLast');
    if (fromDateLast) {
      const toDateLast = subDays(addYears(fromDateLast, 2), 1);
      toDateLastControl?.setValue(toDateLast);
    } else {
      toDateLastControl?.setValue(null);
    }
  }

  disabledFromTodayDate = (current: Date): boolean => {
    return differenceInCalendarDays(current, startOfDay(this.currentDate)) > 0 ||
    differenceInCalendarDays(current, startOfDay(this.januaryFirst2020)) <= 0;
  };
}
